import src from "./brands-mobile.png";
export default { src: src, aspect: 5.2105263157894735, width: 792, height: 152 };